import { retryCancelablePromise } from '../core/utils/retryCancelablePromise';
export class IdentityDomainsService {
    constructor(httpRequest) {
        Object.defineProperty(this, "httpRequest", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: httpRequest
        });
    }
    /**
     * Publish identity domain
     * @returns IdentityDomain OK.
     * @throws ApiError
     */
    requestIdentityDomain({ orgId, requestBody, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'POST', url: '/orgs/{orgId}/identity-domains', path: {
                'orgId': orgId,
            }, body: requestBody, mediaType: 'application/json', errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * List identity domains
     * @returns IdentityDomains OK.
     * @throws ApiError
     */
    listIdentityDomainsByOrgId({ orgId, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/identity-domains', path: {
                'orgId': orgId,
            }, errors: {
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Update identity domain
     * @returns UpdateIdentityDomain OK.
     * @throws ApiError
     */
    updateIdentityDomain({ orgId, domainId, requestBody, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'PATCH', url: '/orgs/{orgId}/identity-domains/{domainId}', path: {
                'orgId': orgId,
                'domainId': domainId,
            }, body: requestBody, mediaType: 'application/json', errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Delete identity domain
     * @returns void
     * @throws ApiError
     */
    removeIdentityDomain({ orgId, domainId, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'DELETE', url: '/orgs/{orgId}/identity-domains/{domainId}', path: {
                'orgId': orgId,
                'domainId': domainId,
            }, errors: {
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Update identity domain verified status
     * @returns UpdateIdentityDomain OK.
     * @throws ApiError
     */
    verifyIdentityDomain({ orgId, domainId, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'PATCH', url: '/orgs/{orgId}/identity-domains/{domainId}/verify', path: {
                'orgId': orgId,
                'domainId': domainId,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Update identity domain reject status
     * @returns IdentityDomain OK.
     * @throws ApiError
     */
    rejectIdentityDomain({ orgId, domainId, requestBody, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'PUT', url: '/orgs/{orgId}/identity-domains/{domainId}/reject', path: {
                'orgId': orgId,
                'domainId': domainId,
            }, body: requestBody, mediaType: 'application/json', errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * List identity domains
     * @returns IdentityDomainList OK.
     * @throws ApiError
     */
    listIdentityDomains({ after, before, sort = '-id', filter, limit = 10, search, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/identity-domains', query: {
                'after': after,
                'before': before,
                'sort': sort,
                'filter': filter,
                'limit': limit,
                'search': search,
            }, errors: {
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
}
//# sourceMappingURL=IdentityDomainsService.js.map